
















import { Component } from 'vue-property-decorator'

import { AbstractModuleUi } from '../../abstract/ui'

import { AttachmentsListModule } from '../AttachmentsList.contracts'

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
@Component<AttachmentsListModuleUi>({
  name: 'AttachmentsListModuleUi'
})
export class AttachmentsListModuleUi extends AbstractModuleUi<AttachmentsListModule> {
  public get hasItems (): boolean {
    return typeof this.data.content.items !== 'undefined' &&
      Array.isArray(this.data.content.items) && this.data.content.items.length > 0
  }
}

export default AttachmentsListModuleUi
